import httpClient from "@/http-client";

export const get = (Options = {}) => {
    return httpClient
        .get("/api/v1/journal-entries", Options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const store = data => {
    return httpClient
        .post("/api/v1/journal-entries", data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const update = (id, data) => {
    return httpClient
        .put(`/api/v1/journal-entries/${id}`, data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const destroy = (id, data) => {
    return httpClient
        .put(`/api/v1/journal-entries/${id}/delete`, data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const refresh = data => {
    return httpClient
        .post("/api/v1/journal-entries/refresh", data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const formViewModel = (Options = {}) => {
    return httpClient
        .get('/api/v1/journal-entries/form-view-models', Options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export default { get, store, update, destroy, refresh, formViewModel };
